import { DesignComponent } from '@design/models/design-component.model';
import { RoofSection } from '@design/models/roof-section.model';
import { createSelector } from '@ngrx/store';
import { selectDesign } from '../design.selector';
import { adapter } from './design-component.reducer';
import { DesignComponentState } from './design-component.state';

const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors();

export namespace fromDesignComponentSelectors {
  export const designComponentStateSelector = createSelector(
    selectDesign,
    (state) => state.designComponent
  );

  export const allDesignComponents = createSelector(
    designComponentStateSelector,
    selectAll
  );

  export const selectDesignComponentById = (id: DesignComponent['id']) =>
    createSelector(designComponentStateSelector, (state: DesignComponentState) => {
      const entities = selectEntities(state);
      return entities[id];
    });

  export const selectDesignComponentsByRoofId = (id: RoofSection['id']) =>
    createSelector(designComponentStateSelector, (state: DesignComponentState) => {
      const entities = selectEntities(state);
      return Object.values(entities).filter((c) => c?.roofId == id);
    });

  export const selectDesignComponentsByAssociatedRoofId = (
    id: RoofSection['id']
  ) =>
    createSelector(designComponentStateSelector, (state: DesignComponentState) => {
      const entities = selectEntities(state);
      return Object.values(entities).filter((c) =>
        c?.roofAssociation?.includes(id)
      );
    });

  export const selectedDesignComponent = createSelector(
    selectDesign,
    (state) => {
      const selectedId = state.ui.selectedObjectId;
      if (!selectedId) {
        return null;
      }
      return state.designComponent.entities[selectedId];
    }
  );

  export const selectedEntitiesByID = (id: DesignComponent['id']) =>
    createSelector(designComponentStateSelector, (state: DesignComponentState) => {
      const entities = selectEntities(state);
      return entities[id];
    });
}
